import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BotaoCadastro from '../../../Componentes/BotaoCadastro';
import CorpoPagina from '../../../Componentes/CorpoPagina';
import ModalConfirmacao from '../../../Componentes/ModalConfirmacao';
import ModalView, { ModalTópico } from '../../../Componentes/ModalView';
import PesquisaInput from '../../../Componentes/PesquisaInput';
import TabelaComponente from '../../../Componentes/TabelaComponente';
import { FixedInput } from '../../../Componentes/TextInput';
import TopicoTexto from '../../../Componentes/TopicoTexto';
import '../../../Estilos/EstiloBotao.css';
import { apiService } from '../../../Services/ApiService';
import { StoreContexto } from '../../../Contexto/Provider';
import useDebounce from '../../../Hooks/debouceSearch';

export default function DesumidificadorLista() {
  const navigate = useNavigate();
  const [dehumidifiers, setDehumidifiers] = useState([]);
  const [totalDehumidifiers, setTotalDehumidifiers] = useState(0);
  const [selectedDehumidifier, setSelectedDehumidifier] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const debounceSearch = useDebounce(searchText, 500);
  const [page, setPage] = useState(0);

  const [confirmModal, setConfirmModal] = useState({
    visible: false,
    message: '',
    id: ''
  });
  const [viewModal, setViewModal] = useState(false);
  const [errorModal, setErrorModal] = useState({
    visible: false,
    message: ''
  });

  const { get, del } = apiService();
  const { auth } = useContext(StoreContexto);

  useEffect(() => {
    fetchDehumidifiers();
  }, [page, debounceSearch]);

  const fetchDehumidifiers = async () => {
    const queryParams = { page, size: 10, search: searchText };
    setIsLoading(true);
    try {
      const { result, total } = await get('dehumidifiers', queryParams);
      result.forEach(result => result.environment ? (result.environmentName = result.environment.name) : null);
      setDehumidifiers(result);
      setTotalDehumidifiers(total);
    } catch (error) {
      setErrorModal({ visible: true, message: 'Erro ao buscar desumidificadores' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = text => setSearchText(text);

  const handleConfirmDeletion = async (id) => {
    setConfirmModal({ visible: false, message: '', id: '' });
    setIsLoading(true);
    try {
      await del(`dehumidifiers/${id}`);
      fetchDehumidifiers();
    } catch (error) {
      setErrorModal({ visible: true, message: 'Erro ao deletar desumidificador' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditClick = id => navigate(`/dehumidifier-form/${id}`);

  const handleMenuItemSelect = (id, item) => {
    if (item === 'Visualizar') {
      setSelectedDehumidifier(dehumidifiers.find(dehumidifier => dehumidifier.id === id));
      setViewModal(true);
    } else if (item === 'Excluir') {
      setConfirmModal({
        visible: true,
        message: 'Deseja realmente deletar este desumidificador?',
        id
      });
    }
  }

  return (
    <CorpoPagina loading={isLoading}>
      {errorModal.visible && (
        <ModalConfirmacao
          aviso={errorModal.message}
          erro={true}
          clicado={() => setErrorModal({ visible: false, message: '' })}
        />
      )}

      {confirmModal.visible && (
        <ModalConfirmacao
          aviso={confirmModal.message}
          confirmar={false}
          clicado={() => handleConfirmDeletion(confirmModal.id)}
          clicadoVolta={() => setConfirmModal({ visible: false, message: '', id: '' })}
        />
      )}

      {viewModal && (
        <ModalView height={541} width={581}>
          <ModalTópico titulo="Visualizar Desumidificador" />
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <div
              style={{
                display: 'flex',
                width: '85%',
                flexDirection: 'column',
                alignItems: 'center',
                padding: 0,
                margin: 0,
                marginTop: 36,
              }}
            >
              <FixedInput
                titulo="Nome"
                padrao={selectedDehumidifier.name}
                tipo="text"
                largura="100%"
                disabled={true}
              />
              <FixedInput
                titulo="ID"
                padrao={selectedDehumidifier.dehumidifierId}
                tipo="text"
                largura="100%"
                disabled={true}
              />
              {selectedDehumidifier.environment && <FixedInput
                titulo="Ambiente"
                padrao={selectedDehumidifier.environmentName}
                tipo="text"
                largura="100%"
                disabled={true}
              />}
            </div>
          </div>
          <button
            id="BotaoCadastro"
            style={{ marginTop: 56 }}
            onClick={() => setViewModal(false)}
          >
            Fechar
          </button>
        </ModalView>
      )}

      <div className="ContainerGeral">
        <TopicoTexto titulo="Lista de Desumidificadores" />
        <BotaoCadastro
          visivel={auth.perfilSalvo === 'OWNER'}
          nome="Cadastrar"
          clicado={() => navigate('/dehumidifier-form')}
        />
        <PesquisaInput placeholder="Insira o nome do desumidificador" onSearch={handleSearch} />
        <TabelaComponente
          colunas={['NOME', 'ID', 'AMBIENTE']}
          campos={['name', 'dehumidifierId', 'environmentName']}
          linhas={dehumidifiers}
          total={totalDehumidifiers}
          paginaAtual={page}
          setPaginaAtual={setPage}
          aviso={!dehumidifiers.length ? 'Não há desumidificadores cadastrados' : 'Buscando desumidificadores...'}
          menuOptions={['Visualizar', 'Excluir']}
          onEditClick={handleEditClick}
          onMenuItemSelect={handleMenuItemSelect}
          goToNextPage={() => nextPage()}
          goToPreviousPage={() => previousPage()}
          entity='dehumidifiers'
          role={ auth.perfilSalvo }
        />
      </div>
    </CorpoPagina>
  );
}
